<template>
    <div>
        <c-search-form :create-div="createDiv"
                       :search-div="searchDiv"
                       :fields="fields"
                       :form-name="formName"
                       :input-create-items="createItems"
                       :input-search-items="searchItems" :rows-per-page-items="[10,20,50]"
                       :accept-copy="false"
                       :accept-delete="false"
                       :accept-create="false"
                       key-property="fileId"
                       search-url="/payment/list"
                       form-type="intable"
                       ref="fileList"
                       @onView="viewPayment">

        </c-search-form>
        <v-dialog v-model="feeDlg" width="800px">
            <v-card>
                <v-card-title>
                    <div class="headline dialog-header">
                        <v-btn @click="feeDlg=false" icon style="float: left">
                            <v-icon>close</v-icon>
                        </v-btn>
                        Phí của thủ tục
                    </div>
                </v-card-title>
                <v-card-text>
                    <FileFee ref="fileFee"/>
                </v-card-text>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
    import CSearchForm from "../../components/form/ManageForm";
    import axios from "axios";
    import {router} from '../../router';
    import FileFee from "../files/FileFee";

    export default {
        name: 'file-list',
        components: {
            FileFee,
            CSearchForm,
        },
        data: () => {
            return {
                formName: "lang.fee.paymentTitle",
                createFormName: "lang.files.titleCreate",
                searchDiv: "searchDivFile",
                createDiv: "createDivFile",
                feeDlg: false,
                fields: [
                    {
                        value: "index",
                        text: "lang.common.index",
                        width: "5%",
                        sortable: false,
                        headerStyle: "text-align:center"
                    },
                    {
                        value: 'paymentNo',
                        text: 'lang.fee.paymentNo',
                        name: 'paymentNo',
                        width: "10%",
                        sortable: false,
                        search: true,
                        headerStyle: "text-align:left",
                        event: "onView"
                    },
                    {
                        value: 'total',
                        text: 'lang.fee.total',
                        name: 'total',
                        width: "10%",
                        sortable: false,
                        search: true,
                        headerStyle: "text-align:left",
                        contentStyle: "text-align:right"
                    },
                    {
                        type: "select",
                        items: [],
                        itemText: "name",
                        itemValue: "id",
                        name: 'customerId',
                        value: 'customerId',
                        text: 'lang.files.customerId',
                        width: "10%",
                        sortable: false,
                        search: true,
                        headerStyle: "text-align:left"
                    },
                    {
                        type: "Date",
                        name: 'paymentDate',
                        value: 'paymentDate',
                        dateFormat: "dd/MM/yyyy hh:mm:ss",
                        text: 'lang.fee.paymentDate',
                        width: "10%",
                        sortable: false,
                        search: true,
                        headerStyle: "text-align:left"
                    },
                    {
                        value: 'task',
                        text: 'lang.task.taskname',
                        name: 'task',
                        width: "10%",
                        sortable: false,
                        search: true,
                        headerStyle: "text-align:left",
                    },
                ],
                feeDlg: false,
            }
        },
        created() {
            axios.get(process.env.VUE_APP_API_URL + "/selectboxdata/active-user", {}).then(
                data => {
                    this.fields.filter(e => e.name == "manageId")[0].items = data.items;

                }
            )
            axios.get(process.env.VUE_APP_API_URL + "/selectboxdata/customer", {}).then(
                data => {
                    this.fields.filter(e => e.name == "customerId")[0].items = data.items;
                }
            )
            axios.get(process.env.VUE_APP_API_URL + "/selectboxdata/procedure", {}).then(
                data => {
                    this.fields.filter(e => e.name == "procedureId")[0].items = data.items;
                }
            )


        },

        methods: {
            viewPayment(payment) {
                this.feeDlg = true;
                this.$refs.fileFee.getFee(payment.fileId, payment.task);
            },
            onViewCancel() {
                document.getElementById(this.searchDiv).style.display = "";
                document.getElementById("viewFileDiv").style.display = "none";
                this.$store.commit("files/setIsView", "0")
            },

        },
        watch: {},

        destroyed() {
        }
    }
</script>
